import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { ICategoryType } from "./categoryType.types";

export const FETCH_CATEGORY_TYPE_LIST_PROGRESS =
	"FETCH_CATEGORY_TYPE_LIST_PROGRESS";
export const FETCH_CATEGORY_TYPE_LIST_SUCCESS =
	"FETCH_CATEGORY_TYPE_LIST_SUCCESS";
export const FETCH_CATEGORY_TYPE_LIST_FAILED =
	"FETCH_CATEGORY_TYPE_LIST_FAILED";

export const fetchCategoryTypeListProgress = () =>
	action(FETCH_CATEGORY_TYPE_LIST_PROGRESS);
export const fetchCategoryTypeListSuccess = (
	data: ICategoryType[],
	totalRecords: number
) =>
	action(FETCH_CATEGORY_TYPE_LIST_SUCCESS, {
		data,
		totalRecords,
	});
export const fetchCategoryTypeListFailed = () =>
	action(FETCH_CATEGORY_TYPE_LIST_FAILED);

export const fetchCategoryTypeListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		status: string,
		date: IDataTableV2DateState["dates"],
		searchValue: IDatatableV2AdvancedSearchFilter,
		company_outlet_uuid?: string
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchCategoryTypeListProgress());
			dispatch(saveLoaderProgress());

			let url = "";
			if (status !== "-1") {
				url += `&status=${status}`;
			}
			if (searchValue.length > 0) {
				url += `&advanceFilter=${JSON.stringify(searchValue)}`;
			}
			if (company_outlet_uuid) {
				url += `&company_outlet_uuid=${company_outlet_uuid}`;
			}

			let finalUrl =
				`/food/get-food-category-type?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
				url;
			const res = await api.get(finalUrl);
			const data: ICategoryType[] = res.data.data;
			const totalRecords = res.data.totalRecords;

			dispatch(fetchCategoryTypeListSuccess(data, totalRecords));
		} catch (err: any) {
			dispatch(fetchCategoryTypeListFailed());
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};
export const upsertCategoryAsync =
	(
		data: ICategoryType,

		onCallback: (isSuccess: boolean) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(saveLoaderProgress());

			await api.post("/category/upsert-category-type", {
				...data,
			});

			const message = "Category type saved successfully.";
			dispatch(
				showMessage({
					type: "success",
					message: message,
					displayAs: "snackbar",
				})
			);
			onCallback(true);
		} catch (err: any) {
			onCallback(false);
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

export const CLEAR_CATGEORY_TYPE_STATE = "CLEAR_CATGEORY_TYPE_STATE";
export const clearCategoryTypeState = () => action(CLEAR_CATGEORY_TYPE_STATE);
